import { Button, Form, Row, Col, Spinner } from "react-bootstrap";
import { MdClose } from "react-icons/md";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import api from '../../api';
import { auth } from "../../firebase";
import { useState, useEffect, useContext } from "react";
import '../css/client/addclient.css';
import Swal from 'sweetalert2';
import { Dimcontext } from "../../context/pagecontext";
import { Datacontext } from "../../context/dataContext";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";

export const AddClient = ({ setAdd, showToast }) => {
    const navigate = useNavigate();
    const { setDim } = useContext(Dimcontext);
    const { fetchClients, client_Count, fetchcountclient } = useContext(Datacontext);
    
    const [cid, setCid] = useState('');
    const [dis, setDis] = useState('');
    const [state, setState] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [hasMobile, setHasMobile] = useState('yes');

    // Generate Client ID based on count
    useEffect(() => {
        if (client_Count?.data?.number) {
            setCid(`TD/${String(client_Count.data.number).padStart(3, "0")}`);
        }
    }, [client_Count]);

    const handleClose = () => {
        setAdd(false);
        setDim(false);
    };

    // const handleGetPincode = async () => {
    //     const pin = document.getElementById("form-pincode").value;
    //     if (pin.length !== 6) return showToast("Please enter a valid 6-digit pincode.");
        
    //     try {
    //         const res = await axios.get(`https://api.postalpincode.in/pincode/${pin}`);
    //         if (res.data[0].Status === "Success") {
    //             const data = res.data[0].PostOffice[0];
    //             setDis(data.District);
    //             setState(data.State);
    //         } else {
    //             showToast("Invalid Pincode.");
    //         }
    //     } catch (err) { 
    //         console.error(err); 
    //         showToast("Failed to fetch location details.");
    //     }
    // };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const formData = Object.fromEntries(new FormData(e.target).entries());
        
        // Validation
        if (!/^[A-Za-z ]{2,50}$/.test(formData.name.trim().replace(/\s+/g, ' '))) {
            setIsLoading(false);
            return showToast("Name can only contain letters.");
        }
        
        if (hasMobile === 'yes') {
            if (!formData.mobile || formData.mobile.length !== 10) {
                setIsLoading(false);
                return showToast("Mobile number must be exactly 10 digits.");
            }
            if (formData.alt_mobile) {
                if (formData.alt_mobile.length !== 10) {
                    setIsLoading(false);
                    return showToast("Alternate mobile number must be exactly 10 digits.");
                }
                if (formData.mobile === formData.alt_mobile) {
                    setIsLoading(false);
                    return showToast("Mobile number and Alternate Mobile number must be different.");
                }
            }
        }

        if (!/^[A-Za-z0-9\s,./-]{5,100}$/.test(formData.address.trim().replace(/\s+/g, ' '))) {
            setIsLoading(false);
            return showToast("Please enter a valid address.");
        }
        
        // Simple manual validation for location
        if (!dis.trim() || !state.trim()) {
            setIsLoading(false);
            return showToast("Please enter district and state.");
        }

        // API Submission
        try {
            const res = await api.post('/add_new', { 
                ...formData, 
                city: dis.toLowerCase().trim(), 
                state: state.toLowerCase().trim() 
            });
            fetchClients();
            await api.put('client_count');
            fetchcountclient();
            
            Swal.fire({
                title: "Success!",
                text: res.data.message,
                icon: "success",
                timer: 2000,
                showConfirmButton: false,
            });
            handleClose();
        } catch (err) { 
            console.error(err); 
            if (err.response?.status === 401) {
                showToast("Session expired. Refreshing...");
                try {
                    const freshToken = await auth.currentUser.getIdToken(true);
                    sessionStorage.setItem("token", freshToken);
                } catch (refreshErr) {
                    showToast("Refresh failed. Logging out.");
                    navigate("/");
                }
            } else {
                showToast("Something went wrong. Please try again.");
            }
        } finally {
            setIsLoading(false);
        }
    };

    const enforceNumericLength = (e, maxLength) => {
        let value = e.target.value.replace(/[^0-9]/g, '');
        if (value.length > maxLength) value = value.slice(0, maxLength);
        e.target.value = value;
    };

    return (
        <div className="addclient-container">
            <ToastContainer />
            
            <div className="addclient-header">
                <div>
                    <h3 className="m-0 text-dark fw-bold">Add New Profile</h3>
                    <p className="text-muted m-0" style={{ fontSize: '0.85rem' }}>Enter details and location.</p>
                </div>
                <button onClick={handleClose} className="close-x-btn"><MdClose size={22} /></button>
            </div>
            
            <Form onSubmit={handleFormSubmit} className="d-flex flex-column" style={{ flex: 1, overflow: 'hidden' }}>
                <SimpleBar style={{ maxHeight: "100%" }}>
                    <div className="addclient-body p-4">
                        <Row className="g-4">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold text-secondary">Client ID</Form.Label>
                                    <Form.Control className="custom-input bg-light text-muted fw-bold" type="text" name="cid" value={cid} readOnly />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">Full Name <span className="text-danger">*</span></Form.Label>
                                    <Form.Control className="custom-input" type="text" name="name" required placeholder="Enter client's full name" />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">Nick Name</Form.Label>
                                    <Form.Control className="custom-input" type="text" name="nick_name" placeholder="Enter nickname (optional)" />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">Client / Broker <span className="text-danger">*</span></Form.Label>
                                    <div className="d-flex gap-3 mt-2">
                                        <Form.Check type="radio" label='Client' value='client' name="role" id='role-client' required defaultChecked className="custom-radio" />
                                        <Form.Check type="radio" label='Broker' value='broker' name="role" id='role-broker' required className="custom-radio" />
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">Gender <span className="text-danger">*</span></Form.Label>
                                    <div className="d-flex gap-3 mt-2">
                                        <Form.Check type="radio" label='Male' value='male' name="gender" id='gender-male' required className="custom-radio" />
                                        <Form.Check type="radio" label='Female' value='female' name="gender" id='gender-female' required className="custom-radio" />
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">Has Mobile Number? <span className="text-danger">*</span></Form.Label>
                                    <div className="d-flex gap-3 mt-2">
                                        <Form.Check 
                                            type="radio" 
                                            label='Yes' 
                                            value='yes' 
                                            name="hasMobile" 
                                            id='mobile-yes' 
                                            onChange={(e) => setHasMobile(e.target.value)}
                                            checked={hasMobile === 'yes'}
                                            className="custom-radio" 
                                        />
                                        <Form.Check 
                                            type="radio" 
                                            label='No' 
                                            value='no' 
                                            name="hasMobile" 
                                            id='mobile-no' 
                                            onChange={(e) => setHasMobile(e.target.value)}
                                            checked={hasMobile === 'no'}
                                            className="custom-radio" 
                                        />
                                    </div>
                                </Form.Group>
                            </Col>

                            {hasMobile === 'yes' && (
                                <>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Mobile Number <span className="text-danger">*</span></Form.Label>
                                            <Form.Control 
                                                required 
                                                type="text"
                                                name="mobile"
                                                inputMode="numeric"
                                                placeholder="10-digit mobile"
                                                className="custom-input fw-medium"
                                                onInput={(e) => enforceNumericLength(e, 10)}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group>
                                            <Form.Label className="fw-semibold">Alternate Mobile Number</Form.Label>
                                            <Form.Control 
                                                type="text"
                                                name="alt_mobile"
                                                inputMode="numeric"
                                                placeholder="10-digit alternate"
                                                className="custom-input fw-medium"
                                                onInput={(e) => enforceNumericLength(e, 10)}
                                            />
                                        </Form.Group>
                                    </Col>
                                </>
                            )}

                            <Col md={12}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">Street Address <span className="text-danger">*</span></Form.Label>
                                    <Form.Control className="custom-input" as="textarea" rows={2} name="address" placeholder="Flat No, Building, Area..." required />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">
                                        Pincode <span className="text-danger">*</span>
                                    </Form.Label>

                                    <div className="d-flex gap-2">
                                        <Form.Control
                                            required
                                            type="text"
                                            id="form-pincode"
                                            name="pincode"
                                            inputMode="numeric"
                                            placeholder="6-digit pin"
                                            className="custom-input fw-medium"
                                            onInput={(e) => enforceNumericLength(e, 6)}
                                        />
                                    </div>
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">
                                        District <span className="text-danger">*</span>
                                    </Form.Label>

                                    <Form.Control
                                        className="custom-input"
                                        type="text"
                                        required
                                        value={dis}
                                        placeholder="Enter district"
                                        onChange={(e) => setDis(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>

                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label className="fw-semibold">
                                        State <span className="text-danger">*</span>
                                    </Form.Label>

                                    <Form.Control
                                        className="custom-input"
                                        type="text"
                                        required
                                        value={state}
                                        placeholder="Enter state"
                                        onChange={(e) => setState(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                </SimpleBar>

                <div className="addclient-footer">
                    <Button variant="light" onClick={handleClose} className="fw-bold px-4 rounded-pill border shadow-sm">Cancel</Button>
                    <Button type="submit" disabled={isLoading} variant="success" className="fw-bold px-4 rounded-pill shadow-sm d-flex align-items-center">
                        {isLoading ? <><Spinner size="sm" className="me-2" /> Saving...</> : "Save Profile"}
                    </Button>
                </div>
            </Form>
        </div>
    );
};